import { render } from "./Error403.vue?vue&type=template&id=042e22aa"
import script from "./Error403.vue?vue&type=script&lang=ts"
export * from "./Error403.vue?vue&type=script&lang=ts"
script.render = render

export default script